export default {
  message: {
    hello: 'Hello',
    welcome: 'Welcome to our website',
    switchLanguage: 'Switch Language',
    home: 'Home',
    about: 'About Us',
    contact: 'Contact Us',
    news: 'News',
    games: 'Game Features',
    download: 'Download',
    community: 'Community',
    products: 'products',
    footer: 'All rights reserved',
    privacyPolicy: 'Privacy Policy',
    accountDeletion: 'Account Deletion',
    lastUpdated: 'Last Updated',
    // Account Deletion
    deletionInApp: 'Delete Account via In-App Request',
    recommended: 'Recommended',
    deletionInAppDesc: 'You can directly request account deletion within the game app. This is the fastest method, and the system will process your request automatically. Please follow these steps:',
    deletionByEmail: 'Delete Account via Email Request',
    ifCannotAccessApp: 'If you cannot access the application',
    deletionByEmailDesc: 'If you are unable to log in to the application, you can request account deletion by sending an email. Please follow these steps:',
    deletionEmailStep1: 'Send an email from your registered email address to our support email',
    deletionEmailStep2: 'Use "Account Deletion Request" as the email subject',
    deletionEmailStep3: 'Include your User ID or registered email address in the email body',
    deletionEmailStep4: 'Attach identity verification information (e.g., purchase receipt screenshots) so we can verify your identity',
    dataRetention: 'Data Deletion & Retention Policy',
    dataRetentionDesc: 'After you submit an account deletion request, we will process your data according to the following policy:',
    dataRetentionDelete: 'Account information, game character data, friend lists, etc. will be deleted within 30 business days',
    dataRetentionKeep: 'Certain transaction records may be retained for a specified period as required by applicable laws and regulations',
    dataRetentionLegal: 'Data that must be retained to comply with legal obligations, resolve disputes, or enforce agreements will be securely stored',
    dataRetentionAnon: 'Anonymized data (that cannot identify individuals) may be retained for statistical analysis purposes',
    importantNotice: 'Important Notice',
    actionRequired: 'Action Required',
    importantNoticeDesc: 'Before requesting account deletion, please note the following:',
    noticeIrreversible: 'Account deletion is irreversible. All game data will be permanently lost and cannot be recovered',
    noticeProgress: 'Any pending game orders, unclaimed rewards, etc. will be forfeited upon deletion',
    noticeSubscription: 'If you have active subscriptions, please cancel them before requesting account deletion',
    noticeRecovery: 'Once deleted, the same account cannot be re-registered or recovered',
    noticeSync: 'Associated third-party accounts (e.g., Google, Apple ID) will be unlinked simultaneously',
    deletionContact: 'Contact Us',
    deletionContactDesc: 'If you encounter any issues during the account deletion process, please contact us through the following:',
    replaceImageHint: 'Replace with screenshot',
    // Footer links
    footerPrivacyPolicy: 'Privacy Policy',
    footerAccountDeletion: 'Account Deletion'
  }
}